import { useState } from "react";
import { InteractionManager } from "react-native";

const MAX_LOADING_TIME = 600;

export const useScreenLoading = () => {
  const [isScreenLoading, setScreenLoading] = useState(true);
  // one or the other
  setTimeout(() => setScreenLoading(false), MAX_LOADING_TIME);
  InteractionManager.runAfterInteractions(() => {
    // 2: Component is done animating
    // 3: Start fetching data that is needed to render UI
    setScreenLoading(false); //Set screenloading prop to false
  });

  return [isScreenLoading, setScreenLoading];
};
